
import { Subject } from 'rxjs';

const subject = new Subject();

export const filterUpdateService = {
    sendFilter: filter => subject.next(filter),
    clearFilter: () => subject.next(),
    getFilter: () => subject.asObservable()
};